<template>
  <div>
    <h1 class="center">BIBLIOTECA</h1>
    <h3 class="center">Gestion de categorias y libros</h3>
    <v-container>
      <div :style="{ width: !$vuetify.breakpoint.smAndDown ? '70%' : '100%' }" style="display: flex;">
        <v-select v-model="selectedId" :items="categorias" item-text="titulo" item-value="id" label="Categoria" outlined
          dense style="max-width:250px" class="mr-3">
          <!-- Ítems del menú -->
          <template v-slot:item="{ item }">
            <div style="font-size: 11pt;">
              {{ item.titulo }}
            </div>
          </template>
          <!-- Texto seleccionado -->
          <template v-slot:selection="{ item }">
            <div style="font-size: 11pt;">
              {{ item.titulo }}
            </div>
          </template>
        </v-select>
        <v-btn :color="$ajustes.colorCabecera" style="color: white;"
          @click="nuevaCategoria = true; formularioCategoriaDialogo = true">NUEVA
          CATEGORIA</v-btn>
        <v-btn class="ml-3" :color="$ajustes.colorCabecera" style="color: white;"
          @click="obtenerCategorias()"><v-icon>mdi-refresh</v-icon></v-btn>
      </div>
    <div>
        <v-btn v-if="selectedId" :color="$ajustes.colorCabecera" style="color: white; width: 130px;"
        @click="libroDatos={};formularioLibroDialogo = true">AGREGAR LIBRO</v-btn>
           <v-btn class="ml-3" :color="$ajustes.colorCabecera" style="color: white;"
          @click="obtenerLibros()"><v-icon>mdi-refresh</v-icon></v-btn>
    </div>
      <br>
      <v-card elevation="0" class="pa-1 pl-4 mb-1" :style="{ border: '1px solid ' + $ajustes.colorCabecera }"
        v-for="libro in libros" :key="'libro_' + libro.id">
        <div style="display: flex;">
          <h3 style="text-align: left;">Fecha inicio: <span style="font-weight: normal;"> {{ libro.fecha_inicio
          }}</span></h3>
          <v-spacer></v-spacer>
          <div style="float: right;">
            <span v-if="false" class="ma-1 pointer" :style="{ fontWeight: libro.destacado == 1 ? 'bold' : null }"
              @click="estadoCurso(libro.id, 'destacado', libro.destacado == 0 ? 1 : 0)">DESTACADO</span>
            <span v-if="false" class="ma-1 pointer" :style="{ fontWeight: libro.habilitado == 1 ? 'bold' : null }"
              @click="estadoCurso(libro.id, 'habilitado', libro.habilitado == 0 ? 1 : 0)">HABILITADO</span>
            <span class="ma-1 pointer" @click="libroDatos = libro; visualizarLibroDialogo = true">VER</span>
            <span class="ma-1 pointer"
              @click="nuevaCategoria = false; libroDatos = libro; formularioLibroDialogo = true">EDITAR</span>
            <span class="ma-1 pointer" @click="eliminarLibro(libro.id)">ELIMINAR</span>
          </div>
        </div>
        <h2 style="text-align: left;"><v-icon v-if="libro.destacado == 1" class="mb-1 r-3" color="gold"
            small>mdi-star-circle</v-icon>{{ libro.titulo }}
        </h2>
      </v-card>
    </v-container>
    <formularioCategoria :propCrear="axios.crearCategoria" :propActualizar="axios.actualizarCategoria"
      :propNuevo="nuevaCategoria" :propCategoria="categoriaDatos" :propDialogo="formularioCategoriaDialogo"
      @closeDialogo=" axios.obtenerCategorias(); formularioCategoriaDialogo = false" />
    <visualizarCategoria :propCurso="categoriaDatos" :propDialogo="visualizarCategoriaDialogo"
      @closeDialogo="visualizarCategoriaDialogo = false" />
    <formularioLibro :propCrear="axios.crearLibro" :propActualizar="axios.actualizarLibro"
      :propLibro="libroDatos" :propCategoriaId="selectedId" :propDialogo="formularioLibroDialogo"
      @closeDialogo=" obtenerLibros(); formularioLibroDialogo = false" />
    <visualizarLibro :propLibro="libroDatos" :propDialogo="visualizarLibroDialogo"
      @closeDialogo="visualizarLibroDialogo = false" />
  </div>
</template>
<script>
import * as axios from "./axios";
import formularioCategoria from "./formularioCategoria";
import visualizarCategoria from "./visualizarCategoria";
import formularioLibro from "./formularioLibro";
import visualizarLibro from "./visualizarLibro";
export default {
  components: {
    formularioCategoria,
    visualizarCategoria,
    formularioLibro,
    visualizarLibro
  },
  data() {
    return {
      selectedId: null,
      categorias: [],
      libros: [],
      opciones: [
        { id: 1, titulo: "Opción 1" },
        { id: 2, titulo: "Opción 2" },
        { id: 3, titulo: "Opción 3" },
      ],
      formularioCategoriaDialogo: false,
      visualizarCategoriaDialogo: false,
      formularioLibroDialogo: false,
      visualizarLibroDialogo: false,
      nuevaCategoria: true,
      categoriaDatos: {},
      libroDatos: {},
      cursos: [],
      axios
    };
  },
  mounted() {
    this.obtenerCategorias()
  },

  created() { },
  watch: {
    selectedId() {
      if (this.selectedId) {
        this.obtenerLibros();
      }
    }
  },
  computed: {},
  methods: {
    async obtenerCategorias() {
      this.categorias = []
      var response = await axios.obtenerCategorias()
      this.categorias = response.data
    },
    async obtenerLibros() {
      this.libros = []
      var response = await axios.obtenerLibros(this.selectedId)
      if (response.data&&response.data.length!=0) {
        this.libros = response.data
      }
    },
    
    async eliminarLibro(libroId) {
      await axios.eliminarLibro(libroId)
      this.obtenerLibros()
    },
    continuar() { },
    close() { },
  },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
